/* CONTEXTO
 * Campo areia: fato inerte. É o único bloco que não opina. */

import { Link } from 'react-router-dom';

import { Celula } from '@/componentes/celula';
import { Hexinho } from '@/componentes/hexagono';
import { Button } from '@/componentes/ui/button';
import type { Integrador, Parametros, Projeto } from '@/dados';

import { quantia } from './grandezas';
import type { NavegarPara } from './salvamento';

export function Contexto({
  integrador,
  projeto,
  p,
  emVoo,
  pendente,
  confirmado,
  erroDoServidor,
  aoNavegar,
}: {
  integrador: Integrador | null;
  projeto: Projeto | null;
  p: Parametros;
  emVoo: number;
  pendente: boolean;
  confirmado: boolean;
  erroDoServidor: boolean;
  aoNavegar: NavegarPara;
}) {
  return (
    <Celula campo="areia" respiro="justo" assenta className="flex flex-wrap items-center gap-4">
      <div className="border-fio grid gap-0.5 pr-4 mesa:border-r">
        <span className="rotulo">Empresa</span>
        <b className="text-corpo font-semibold">
          {integrador?.nome_empresa ?? 'Empresa sem cadastro'}
        </b>
      </div>
      <div className="grid gap-0.5">
        <span className="rotulo">Projeto em análise</span>
        <b className="text-corpo font-semibold">{projeto?.nome_projeto ?? 'Nenhum projeto'}</b>
      </div>

      <div className="flex flex-wrap gap-2">
        <span className="bg-lavado text-tinta-2 inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-nota">
          <Hexinho cor="var(--marca-teal)" tamanho={11} />
          {p.kwp > 0 ? `${quantia(p.kwp, 2)} kWp` : 'potência não informada'}
        </span>
        <span className="bg-lavado text-tinta-2 inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-nota">
          <Hexinho cor="var(--marca-teal)" tamanho={11} />
          {p.mods > 0 ? `${quantia(p.mods, 0)} módulos` : 'módulos não informados'}
        </span>
      </div>

      <span className="flex-1" />

      <span className="text-tinta-2 text-nota" role="status">
        {emVoo > 0
          ? 'Salvando'
          : pendente
            ? 'Edição pendente'
            : confirmado
              ? 'Conferido com o servidor'
              : erroDoServidor
                ? 'O servidor não confirmou os números'
                : 'Conferindo com o servidor'}
      </span>

      <Button variant="outline" size="sm" asChild>
        <Link to="/projeto?novo=1" onClick={aoNavegar('/projeto?novo=1')}>
          Novo projeto
        </Link>
      </Button>
    </Celula>
  );
}
